import { render, staticRenderFns } from "./ViewAcademyMessage.vue?vue&type=template&id=41fa3716&scoped=true"
import script from "./ViewAcademyMessage.vue?vue&type=script&lang=js"
export * from "./ViewAcademyMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fa3716",
  null
  
)

export default component.exports